import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View, Text } from '@olxbr/design-system'

import TextWithCheck from '../../molecules/TextWithCheck'
import SellIcon from '../../atoms/SellIcon'
import Subtitle from '../../atoms/Subtitle'
import LinkButton from '../../atoms/LinkButton'
import medias from '../../../util/medias'

const Description = styled(Subtitle)`
  margin-left: 8px;
  line-height: ${14 * 1.5}px;
  font-size: 14px;
  font-size: calc(12px + (14 - 12) * ((100vw - 360px) / (1024 - 360)));
  ${medias.fontMax`font-size: 14px;`};
  ${medias.fontMin`font-size: 12px;`};
`

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled(Text)`
  margin-top: 8px;
  font-size: 16px;
  font-weight: 700;
`

const Itens = styled(View)`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const Row = styled(View)`
  margin-top: 16px;
`

const CallToSell = ({ onClick }) => (
  <Content>
    <SellIcon />
    <Title>Venda o que não usa mais</Title>
    <Itens>
      <Row>
        <TextWithCheck
          render={() => <Description>Crie um anúncio em menos de 5 minutos.</Description>}
        />
      </Row>
      <Row>
        <TextWithCheck
          render={() => <Description>Negocie direto com compradores via chat.</Description>}
        />
      </Row>
      <Row>
        <TextWithCheck
          render={() => <Description>100% da grana é sua, sem intermediárias.</Description>}
        />
      </Row>
    </Itens>
    <Row>
      <LinkButton
        href="https://www2.olx.com.br/ai"
        text="Anunciar agora"
        width="180px"
        height="48px"
        onClick={onClick}
      />
    </Row>
  </Content>
)

CallToSell.propTypes = {
  onClick: PropTypes.func,
}

export default CallToSell
